import { computed, ref, watch } from '@vue/composition-api';
import { useStorage } from '@vueuse/core';
import Vue from 'vue';
import wujiFetch from '@/utils/wujiFetch';
import getXyManagePathPrefix from '@/utils/getXyManagePathPrefix';
const GOGO_SWITCH_KEY = 'wuji:gogo:open';
// 是否在部署配置中开启功能
export const getDeployOpen = () => window?.GLOBAL_INFO?.wujiGoConfig?.enable || false;
// 是否开启了 wuji gogo 后端构建能力
const gogoBackendEnabled = Vue.observable({ value: false });
export const getGogoBackendEnabled = () => gogoBackendEnabled.value;
export const fetchGogoBackendEnabled = async () => {
    const query = new URLSearchParams(window.location.search);
    const projectId = query.get('projectid') || query.get('projectId');
    // 获取项目是否支持构建后端
    await (async () => {
        const resp = await wujiFetch(`${getXyManagePathPrefix({ envId: 'dev' })}/ai-project/backend/allocate?projectId=${projectId}`);
        return !!resp;
    })().catch(() => false)
        .then(v => gogoBackendEnabled.value = (!!v));
};
// 是否在 Query 参数中开启测试模式
export const getSearchDevOpen = () => new URLSearchParams(window.location.search).has('gogoDev');
// 获取测试版本地址
export const getTestBaseUrl = () => new URLSearchParams(window.location.search).get('testBaseUrl');
const isLocalGogoOpen = useStorage(GOGO_SWITCH_KEY, false);
export function useGogo() {
    const isDeployOpen = ref(getDeployOpen());
    const isSearchDevOpen = ref(getSearchDevOpen());
    const isOpen = computed(() => isDeployOpen.value || isSearchDevOpen.value || isLocalGogoOpen.value);
    // 如果 Query 中开启过测试模式，则本地存储为开启状态
    watch(isSearchDevOpen, (val) => {
        if (val)
            isLocalGogoOpen.value = true;
    }, { immediate: true });
    return {
        isOpen,
    };
}
